import React, { useRef, useEffect, useState } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'

interface ReviewScaffoldProps {
  left: React.ReactNode
  center: React.ReactNode
  right: React.ReactNode
  datasetName?: string | undefined
}

const ReviewScaffold: React.FC<ReviewScaffoldProps> = ({ left, center, right }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const rowRef = useRef<HTMLDivElement>(null)
  const [rowHeight, setRowHeight] = useState<number | null>(null)

  useEffect(() => {
    const container = containerRef.current
    const row = rowRef.current
    if (!container || !row) return

    const updateHeight = () => {
      const containerRect = container.getBoundingClientRect()
      setRowHeight(containerRect.height)
    }

    // Initial height
    updateHeight()

    // Use ResizeObserver to track container size changes
    const resizeObserver = new ResizeObserver(() => {
      updateHeight()
    })

    resizeObserver.observe(container)

    // Also listen to window resize as fallback
    window.addEventListener('resize', updateHeight)

    return () => {
      resizeObserver.disconnect()
      window.removeEventListener('resize', updateHeight)
    }
  }, [])

  return (
    <Container
      fluid
      ref={containerRef}
      className="p-0 h-100"
      style={{ height: '100%', maxHeight: '100%', overflow: 'hidden' }}
    >
      <Row
        ref={rowRef}
        className="g-0 align-items-stretch m-0 h-100"
        style={{ height: '100%', maxHeight: '100%', minHeight: 0 }}
      >
        {/* Left Panel - Optional (currently null in most cases) */}
        {left && (
          <Col
            xs={12}
            lg={2}
            className="d-flex flex-column p-0"
            style={{
              minHeight: 0,
              maxHeight: '100%',
              height: '100%',
              borderRight: '1px solid rgba(255, 255, 255, 0.1)',
              overflow: 'hidden',
            }}
          >
            {left}
          </Col>
        )}

        {/* Center Panel - Main Content Area (Snippets: ~75% width) */}
        <Col
          xs={12}
          lg={left ? 7 : 9}
          className="d-flex flex-column p-0"
          style={{
            height: '100%',
            maxHeight: '100%',
            backgroundColor: '#161b22',
            borderRight: '1px solid rgba(255, 255, 255, 0.1)',
          }}
        >
          {center}
        </Col>

        {/* Right Panel - Image Preview (Small: ~25% width) */}
        <Col
          xs={12}
          lg={3}
          className="p-0 d-flex"
          style={{ height: '100%', maxHeight: '100%', minHeight: 0 }}
        >
          <div
            className="w-100 h-100 position-relative flex-grow-1"
            style={{
              height: '100%',
              minHeight: 0,
              backgroundColor: '#0d1117',
              overflow: 'hidden',
            }}
          >
            {right}
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default ReviewScaffold
